import { fromJS } from "immutable";
import { call, put } from "redux-saga/effects";
import { authActions } from "../../../actions/auth";
import { errorsActions } from "../../../actions/errors";

// Actions
import { profileActions } from "../../../actions/profile";

// Api
import {
  fetchTrickDPP,
  fetchTrickDPP1,
  getTokenTagGameStatus,
  productCharacteristics,
  tokenizedProductBrandInfo,
  tokenizedProductInfo,
  transactionHistory,
} from "../../../api";
import { mapDPPModel } from "../../../redux/model/DPPModel";
import { mapTransactionHistoryModel } from "../../../redux/model/transactionHistoryModel";
import { mapSpaceToProductInfo } from "../../../pages/private/ProductInfo/helpers";
import { Mixpanel } from "../../../services/Mixpanel";

export function* getProductBySlug({ payload: { slug, callback, history } }) {
  yield put(authActions.startLoading());
  const res = yield call(productCharacteristics, slug);
  yield put(authActions.finishLoading());
  if (res?.response && res?.response?.uniqueId) {
    if (res.response.is_space) {
      const mappedData = mapSpaceToProductInfo(res.response);
      yield put(profileActions.setProductInfo(mappedData));
    } else {
      yield put(profileActions.fetchProdByToken(res.response.uniqueId));
      yield put(profileActions.fetchTokenizedBrandInfo(res.response.uniqueId));
      yield put(profileActions.fetchTransactionHistory(res.response.uniqueId));
    }
    if (callback) {
      yield call(callback, res.response);
    }
    Mixpanel.track("New Product");
  } else {
    if (res?.message === "This chip/item link has been deactivated.") {
      yield put(profileActions.setProductError(res.message));
    } else {
      yield put(profileActions.setProductError("PAGE_NOT_ACTIVE"));
    }
  }
}

export function* getProductByToken({ payload: { token, cb, history } }) {
  yield put(authActions.startLoading());
  const res = yield call(tokenizedProductInfo, token);
  yield put(authActions.finishLoading());
  if (res?.response) {
    let finalProductInfo = res.response;
    if (finalProductInfo.is_space) {
       finalProductInfo = mapSpaceToProductInfo(finalProductInfo);
    }
    yield put(profileActions.setProductInfo(finalProductInfo));
    Mixpanel.track("New Product");
  } else {
    if (res?.message === "This chip/item link has been deactivated.") {
      yield put(profileActions.setProductError(res.message));
    } else {
      yield put(profileActions.setProductError("PAGE_NOT_ACTIVE"));
    }
  }
  if (cb) {
    yield call(cb);
  }
}

export function* getTransactionHistory({ payload: { token } }) {
  yield put(authActions.startLoading());
  if (!token || token === "null") {
    yield put(authActions.finishLoading());
    return;
  }
  const res = yield call(transactionHistory, token);
  yield put(authActions.finishLoading());
  if (res?.response) {
    const data = res.response;
    const history = res.response[0].history.map((tx) =>
      mapTransactionHistoryModel(fromJS(tx))
    );
    data[0].history = history;
    yield put(profileActions.setTransactionHistory(data));
    Mixpanel.track("New Product");
  }
}

export function* getTokenizedProductBrandInfo({ payload: { token } }) {
  yield put(authActions.startLoading());
  const res = yield call(tokenizedProductBrandInfo, token);
  yield put(authActions.finishLoading());
  if (res?.response) {
    yield put(profileActions.setTokenizedProductBrandInfo(res.response));
    Mixpanel.track("New Product");
  }
}

export function* fetchTokenTagGameStatus({ payload: { gameId } }) {
  try {
    const res = yield call(getTokenTagGameStatus, gameId);
    if (res?.response) {
      yield put(profileActions.setTokenTagGameStatus(res.response));
    }
  } catch (error) {
    console.error("Failed to fetch token tag game status:", error);
  }
}
